var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"header"},[_c('b-col',{attrs:{"lg":"6"}},[_c('breadcrumb',{staticStyle:{"margin-left":"15px"}})],1),_c('b-col',{attrs:{"lg":"6"}}),(['TrackerDashboard','Tracker','Dashboard'].includes( _vm.$route.name ))?_c('dashboard-selector'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }